import { round } from 'lodash-es';

export default function roundScore(score: number = 0): number {
  return round(score, 1);
}
